import request from '@/utils/request'

export function coupons (query) {
  return request({
    url: '/coupon/couponlist',
    method: 'get',
    params: query
  })
}

export function coupon (query) {
  return request({
    url: '/coupon/index',
    method: 'get',
    params: query
  })
}

export function canUseCoupons (query) {
  return request({
    url: '/coupon/search',
    method: 'get',
    params: query
  })
}

export function useCoupons (query) {
  return request({
    url: '/coupon/useCoupon',
    method: 'post',
    data: query
  })
}

export function receiveCounpon(query) {
  return request({
    url: '/coupon/receive',
    method: 'post',
    data: query
  })
}

export function isShowCouponLead (query) {
  return request({
    url: '/coupon/isShowCouponLead',
    method: 'get',
    params: query
  })
}